module.exports = __webpack_public_path__ + "img/b2e2a48.jpg";